/**
 * `.steps` do mockup: Leitura → Dados → WhatsApp → Formulário (o passo
 * "WhatsApp" só existe quando o funil tem canal; "Formulário" só quando tem
 * modelo). `current` é o índice do passo ativo; os anteriores ficam `done`.
 */
import React from 'react';

import { Icon } from '@/shared/icons';

export interface CaptureStepperProps {
  steps: string[];
  current: number;
}

export const CaptureStepper: React.FC<CaptureStepperProps> = ({ steps, current }) => (
  <div className="flex items-center mb-4 -mt-0.5" data-testid="capture-stepper">
    {steps.map((label, i) => {
      const done = i < current;
      const on = i === current;
      return (
        <React.Fragment key={label}>
          <div className="flex items-center gap-[7px] min-w-0" data-testid={`capture-step-${i}`} data-state={done ? 'done' : on ? 'on' : 'todo'}>
            <span
              className="w-[22px] h-[22px] rounded-full text-[11px] font-bold flex items-center justify-center flex-none"
              style={done
                ? { background: '#8b5cf6', border: '1.5px solid #8b5cf6', color: '#fff' }
                : on
                  ? { background: '#fff', border: '1.5px solid #8b5cf6', color: '#7c3aed', boxShadow: '0 0 0 3px #f3e8ff' }
                  : { background: '#fff', border: '1.5px solid #cbd5e1', color: '#94a3b8' }}
            >
              {done ? <Icon name="check" size={12} /> : i + 1}
            </span>
            <span className={`text-xs whitespace-nowrap ${on ? 'font-semibold' : 'font-medium'} ${on ? '' : 'hidden sm:inline'}`} style={{ color: on ? '#1e293b' : done ? '#64748b' : '#94a3b8' }}>
              {label}
            </span>
          </div>
          {i < steps.length - 1 && <span className="flex-1 h-px mx-2.5 min-w-[14px]" style={{ background: done ? '#c4b5fd' : '#e2e8f0' }} />}
        </React.Fragment>
      );
    })}
  </div>
);

/** Passos da sessão conforme a foto da config (D16). */
export const buildCaptureSteps = (hasChannel: boolean, hasForm: boolean): string[] => [
  'Leitura',
  'Dados',
  ...(hasChannel ? ['WhatsApp'] : []),
  ...(hasForm ? ['Formulário'] : []),
];
